import { render } from "./RuleTypeBadge.vue?vue&type=template&id=7bdb1be6"
import script from "./RuleTypeBadge.vue?vue&type=script&lang=js"
export * from "./RuleTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleTypeBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bdb1be6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bdb1be6', __exports__)) {
    api.reload('7bdb1be6', __exports__)
  }
  
  module.hot.accept("./RuleTypeBadge.vue?vue&type=template&id=7bdb1be6", () => {
    api.rerender('7bdb1be6', render)
  })

}


export default __exports__